<template>
  <div>
    <paginate v-if="items"
              :click-handler="clickHandler"
              :page-count="items.last_page"
              :page-range="3"
              :margin-pages="2"
              :prev-text="'&laquo'"
              :next-text="'&raquo'"
              :container-class="'pagination'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
              :active-class="'active green_btn'">
    </paginate>
  </div>
</template>

<script>
  import Paginate from 'vuejs-paginate'

  export default {
    components: {
      Paginate,
    },
    props: {
      items: {
        type: Object,
        default: {},
        require: true,
      },
      clickHandler: {
        type: Function,
        default: () => {}
      },
      /*page: {
        type: Number,
        default: 1,
      },*/
    }
  }
</script>
